// Lifecycle is independent of phase, health, archive and capacity schedules.
export const PROJECT_STAGES = Object.freeze({
  intake: "Intake", active: "Active", on_hold: "On hold",
  completed: "Completed", cancelled: "Cancelled",
});
export const DEFAULT_PROJECT_STAGES = Object.freeze(["intake", "active", "on_hold"]);
export const isTerminalProject = project => ["completed", "cancelled"].includes(project?.stage);
export const isCurrentProject = project => Boolean(project) && !isTerminalProject(project);
export const isActiveProject = project => project?.stage === "active";

export function projectDate(value) {
  if (value == null || value === "") return null;
  const raw = value instanceof Date ? value.toISOString().slice(0, 10) : String(value).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return null;
  const date = new Date(`${raw}T00:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === raw ? raw : null;
}

export function stageTransition(before, patch, today) {
  const stage = "stage" in patch ? patch.stage : before.stage;
  if (!Object.hasOwn(PROJECT_STAGES, stage)) throw new Error("Invalid stage");
  if ("stageNote" in patch && typeof patch.stageNote !== "string") throw new Error("stageNote must be a string");
  if ("completedOn" in patch && patch.completedOn != null && patch.completedOn !== ""
      && (typeof patch.completedOn !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(patch.completedOn) || !projectDate(patch.completedOn))) {
    throw new Error("completedOn must be a valid YYYY-MM-DD date");
  }
  if (stage !== "completed" && patch.completedOn) throw new Error("completedOn is only allowed for Completed");
  const completedOn = stage === "completed"
    ? projectDate(patch.completedOn)
      || (before.stage === "completed" ? projectDate(before.completed_on ?? before.completedOn) : null)
      || projectDate(patch.fdobDate ?? before.fdob_date ?? before.fdobDate)
      || projectDate(today)
    : null;
  if (stage === "completed" && !completedOn) throw new Error("Completed requires a completion date");
  return { stage, completedOn, note: patch.stageNote?.trim() || null };
}

export function shouldNudgeCompletion(project, today) {
  const fdob = projectDate(project?.fdobDate);
  return project?.stage === "active" && project.phase === "closeout" && Boolean(fdob && fdob < projectDate(today));
}
